/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Box, Flex, Button } from 'rebass';

import { H2, H3, P } from '../components/Text';
import { Layout } from '../layouts/Layout';
import { useTranslation } from '../i18n/TranslationContext';

const Section: React.FC = ({ children }) => (
  <Box sx={{ my: [4, 6], display: 'flex', flexDirection: ['column', 'row'] }}>
    {children}
  </Box>
);

const volunteerURL = 'http://bit.ly/Interaction21Volunteer';

const GetInvolvedPage = () => {
  const t = useTranslation();

  return (
    <Layout title={t('get_involved_heading')}>
      <Box
        sx={{
          height: 426,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <H2 sx={{ mb: [3, 4], textAlign: 'center', maxWidth: 700 }}>
          Collectively, we can make a difference in these perilous times.
        </H2>
      </Box>
      {/* Volunteer section  */}
      <Section>
        <H3 sx={{ flex: 2 }}>Volunteer with us</H3>
        <Box sx={{ flex: 3, display: 'flex', flexDirection: 'column' }}>
          <P>
            Are you interested in being in the thick of the action with a crew
            of dedicated folks? If so, we'd love to hear from you! Please fill
            out our{' '}
            <a
              href={volunteerURL}
              target="_blank"
              sx={{ variant: 'variants.link' }}
            >
              volunteer application form
            </a>{' '}
            and someone from our team will be in touch.
          </P>
          <Flex>
            <Button
              as="a"
              href={volunteerURL}
              target="_blank"
              sx={{
                display: 'flex',
                alignItems: 'center',
                maxWidth: ['100%', 'auto'],
                mt: 3,
              }}
            >
              Volunteer with us ↗
            </Button>
          </Flex>
        </Box>
      </Section>
      {/* Propose a talk section  */}
      <Section>
        <H3 sx={{ flex: 2 }}>Propose an idea</H3>
        <Box sx={{ flex: 3, display: 'flex', flexDirection: 'column' }}>
          <P sx={{ mb: [3, null] }}>
            Looking to share your ideas with our community? Perhaps you have a
            new and inspiring perspective that perfectly aligns with our
            conference theme?
          </P>
          <Flex>
            <Button
              as="a"
              href="/call-for-proposals"
              sx={{
                alignItems: 'center',
                lineHeight: '32px',
                textAlign: 'left',
                maxWidth: ['100%', 'auto'],
                mt: 3,
                cursor: 'pointer',
              }}
            >
              Submit a proposal
            </Button>
          </Flex>
        </Box>
      </Section>
      {/* Sponsor section  */}
      <Section>
        <H3 sx={{ flex: 2 }}>Become a sponsor</H3>
        <P sx={{ flex: 3 }}>
          Interaction Week is possible thanks to our incredible sponsors who
          support us, year after year. <br />
          If you are interested in partnering with us, please get in touch at{' '}
          <a
            href="mailto:sponsorship@ixda.org"
            sx={{ variant: 'variants.link' }}
          >
            sponsorship@ixda.org
          </a>
          .
        </P>
        {/* <P>
          Join us in advancing the overall interaction design practice worldwide 
          and takes a look at our <a sx={{ variant: 'variants.link' }}>sponsorship deck</a> - there are options for everyone!
        </P>
        <Button
          as="a"
          href="#"
          sx={{
            display: 'flex',
            alignItems: 'center',
            height: '48px',
            textAlign: 'left',
            maxWidth: ['100%', '300px'],
            cursor: 'pointer',
            mt: 3
          }}
        >
          Become a sponsor
        </Button> */}
      </Section>
    </Layout>
  );
};

export default GetInvolvedPage;
